<template>
  <div class="mkt-settings">
    <div class="mkt-group">
      <div class="mkt-question">{{ $t('marketplace.whoCanPublish') }}</div>
      <f7-list inset strong no-hairlines>
        <f7-list-item
          radio
          radio-icon="start"
          :title="$t('marketplace.whoAdminsOnly')"
          :subtitle="$t('marketplace.whoAdminsOnlySub')"
          name="whoCanPublish"
          :checked="s.whoCanPublish === 'ADMINS_ONLY'"
          @change="set('whoCanPublish', 'ADMINS_ONLY')"
        />
        <f7-list-item
          radio
          radio-icon="start"
          :title="$t('marketplace.whoMembersApproval')"
          :subtitle="$t('marketplace.whoMembersApprovalSub')"
          name="whoCanPublish"
          :checked="s.whoCanPublish === 'MEMBERS_APPROVAL'"
          @change="set('whoCanPublish', 'MEMBERS_APPROVAL')"
        />
        <f7-list-item
          radio
          radio-icon="start"
          :title="$t('marketplace.whoApprovedSellers')"
          :subtitle="$t('marketplace.whoApprovedSellersSub')"
          name="whoCanPublish"
          :checked="s.whoCanPublish === 'APPROVED_SELLERS'"
          @change="set('whoCanPublish', 'APPROVED_SELLERS')"
        />
      </f7-list>
    </div>

    <div class="mkt-group">
      <f7-list inset strong no-hairlines>
        <f7-list-item :title="$t('marketplace.requiresApproval')">
          <template #after>
            <f7-toggle v-model:checked="s.requiresApproval" color="green" />
          </template>
        </f7-list-item>
        <f7-list-item
          :title="$t('marketplace.allowExternalSellers')"
          :subtitle="$t('marketplace.allowExternalSellersSub')"
        >
          <template #after>
            <f7-toggle v-model:checked="s.allowExternalSellers" color="green" />
          </template>
        </f7-list-item>
      </f7-list>
    </div>

    <div class="mkt-group">
      <div class="mkt-question">{{ $t('marketplace.whereAppears') }}</div>
      <f7-list inset strong>
        <f7-list-item :title="$t('marketplace.placementHome')">
          <template #media>
            <f7-checkbox
              :checked="s.placement.homePage"
              @change="setPlacement('homePage', $event.target.checked)"
            />
          </template>
        </f7-list-item>
        <f7-list-item :title="$t('marketplace.placementNav')">
          <template #media>
            <f7-checkbox
              :checked="s.placement.navigation"
              @change="setPlacement('navigation', $event.target.checked)"
            />
          </template>
        </f7-list-item>
        <f7-list-item :title="$t('marketplace.placementDigest')">
          <template #media>
            <f7-checkbox
              :checked="s.placement.weeklyDigest"
              @change="setPlacement('weeklyDigest', $event.target.checked)"
            />
          </template>
        </f7-list-item>
      </f7-list>
    </div>

    <p class="mkt-defaults-note">{{ $t('marketplace.defaultsNote') }}</p>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { MARKETPLACE_DEFAULTS } from '../../js/pinia-stores/marketplace.js'

const props = defineProps({
  modelValue: { type: Object, default: null },
})
const emit = defineEmits(['update:modelValue'])

const s = ref({
  ...MARKETPLACE_DEFAULTS,
  ...props.modelValue,
  placement: {
    ...MARKETPLACE_DEFAULTS.placement,
    ...(props.modelValue?.placement || {}),
  },
})

function emitChange() {
  emit('update:modelValue', JSON.parse(JSON.stringify(s.value)))
}

function set(key, value) {
  s.value[key] = value
  emitChange()
}

function setPlacement(key, value) {
  s.value.placement = { ...s.value.placement, [key]: value }
  emitChange()
}

watch(s, emitChange, { deep: true })
</script>

<style scoped>
.mkt-settings { padding-bottom: 8px; margin-left:-8px; margin-right:-8px; }
.mkt-group { margin-bottom: 4px; }
.mkt-question {
  font-size: 13px;
  font-weight: 600;
  color: var(--f7-theme-color);
  padding: 8px 16px 0;
}
.mkt-defaults-note {
  font-size: 12px;
  line-height: 1.5;
  color: var(--f7-on-surface-variant, #8e8e93);
  padding: 8px 16px 0;
}
</style>
